import { useFormikContext } from 'formik';
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { Button } from 'primereact/button';
import { getFormattedSubscriptionCost } from '../../utils/AppUtil';
import { AccountType } from '../../shared/Constants';
import { Loading } from '../../components/Loading';

const i18nMessages = defineMessages({
  newSubscriptionPriceAndPayment: {
    id: 'account.subscription.new-subscription-price-and-payment',
    defaultMessage: 'New NoLimit subscription price and payment',
  },
  discount: {
    id: 'account.subscription.discount',
    defaultMessage: 'Discount:',
  },
  priceForSubscriptionPeriod: {
    id: 'account.subscription.price-for-subscription-period',
    defaultMessage: 'Price for subscription period:',
  },
  clientPriceForSubscriptionPeriod: {
    id: 'account.subscription.client-price-for-subscription-period',
    defaultMessage: 'Client price for subscription period:',
  },
  gscPriceForSubscriptionPeriod: {
    id: 'account.subscription.gsc-price-for-subscription-period',
    defaultMessage: 'GSC price for subscription period:',
  },
  payNow: {
    id: 'account.generic.pay-now',
    defaultMessage: 'Pay now',
  },
});

const NewSubscriptionPrices = ({
  subscriptionCost,
  subscriptionCostBeforeGscDiscount,
  discountPercentage,
  managingAccount,
  clientAccount,
  changeSubscriptionLoading,
}) => {
  const { formatMessage } = useIntl();
  const { isSubmitting, handleSubmit } = useFormikContext();

  const { type: managingAccountType } = managingAccount;

  const { type: clientAccountType } = clientAccount;

  const gscIsBuyingSubscriptionForClient =
    managingAccountType === AccountType.GSC && clientAccountType === AccountType.NBM_CLIENT;

  const regularSubscriptionCostSection = (
    <div className="flex-box">
      <div>{formatMessage(i18nMessages.priceForSubscriptionPeriod)}</div>
      <div>{`$${subscriptionCost.toLocaleString()}`}</div>
    </div>
  );

  const gscForClientSubscriptionCostSection = (
    <>
      <div className="flex-box">
        <div>{formatMessage(i18nMessages.clientPriceForSubscriptionPeriod)}</div>
        <div>{getFormattedSubscriptionCost(subscriptionCostBeforeGscDiscount)}</div>
      </div>
      <div className="flex-box">
        <div>{formatMessage(i18nMessages.gscPriceForSubscriptionPeriod)}</div>
        <div>{getFormattedSubscriptionCost(subscriptionCost)}</div>
      </div>
    </>
  );

  const creditCostSection = gscIsBuyingSubscriptionForClient
    ? gscForClientSubscriptionCostSection
    : regularSubscriptionCostSection;

  return (
    <>
      <section className="form-section">
        <p>
          <span className="underlined">{formatMessage(i18nMessages.newSubscriptionPriceAndPayment)}</span>
        </p>
        <div className="flex-box">
          <div>{formatMessage(i18nMessages.discount)}</div>
          <div>{`${discountPercentage}%`}</div>
        </div>
        {creditCostSection}
      </section>
      <section className="buttons">
        {changeSubscriptionLoading ? (
          <Loading size="small" />
        ) : (
          <Button
            type="submit"
            disabled={isSubmitting}
            label={formatMessage(i18nMessages.payNow)}
            className="button"
            onClick={handleSubmit}
          />
        )}
      </section>
    </>
  );
};

NewSubscriptionPrices.NewSubscriptionPrices = {
  subscriptionPeriods: PropTypes.arrayOf(PropTypes.any).isRequired,
  subscriptionCost: PropTypes.string.isRequired,
  subscriptionCostBeforeGscDiscount: PropTypes.string.isRequired,
  discountPercentage: PropTypes.string.isRequired,
  managingAccount: PropTypes.objectOf(PropTypes.any).isRequired,
  clientAccount: PropTypes.objectOf(PropTypes.any).isRequired,
  changeSubscriptionLoading: PropTypes.bool.isRequired,
};

export default NewSubscriptionPrices;
